/** @typedef {import('./Types/BlogsWidgetProps').default} Props */

import { translate } from '../../Internationalization';
import BlogsEmbed from './BlogsEmbed';
import flags from '../../../shared/Flags';
import GatedBlogs from './GatedBlogs/GatedBlogs';
import Loading from '../../../shared/Loading';
import PageHeading from '../../../shared/PageHeading/PageHeading';
import React from 'react';
import useIsGated from '../../../Hooks/Shared/useIsGated/useIsGated';

const title = (
	<header className="mt-10 mb-6">
		<PageHeading>{translate('agent.pages.blogs.view.title')}</PageHeading>
		<p className="mt-4">
			{translate('agent.pages.blogs.view.description')}
		</p>
	</header>
);

/** @returns {JSX.Element} */
function Blogs() {
	const { isGated, isGettingData } = useIsGated(flags.agent.blogWidget);

	if (isGettingData) {
		return (
			<section>
				{title}
				<Loading />
			</section>
		);
	}

	if (isGated) {
		return (
			<section>
				{title}
				<GatedBlogs />
			</section>
		);
	}

	return (
		<section>
			{title}
			<BlogsEmbed />
		</section>
	);
}

export default React.memo(Blogs);
